/* eslint-disable sonarjs/no-nested-template-literals */
import { createApi } from '@reduxjs/toolkit/query/react';

import { ResponseError } from '@/types/Error';
import {
  RecommendationPageData,
  RecommendationPageRequest,
  RecommendationPageViewData,
} from '@/types/recommendationPage';
import { SuccessResponse } from '@/types/Success';

import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

const applicationJson = 'application/json';

const contentTypes = {
  applicationJson: 'application/json',
  rawContentType: 'text/plain',
};

export const recommendationPagesApi = createApi({
  reducerPath: 'recommendationPagesApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({ basePath: '/RecommendationPage' }),
  tagTypes: ['RecommendationPage', 'RecommendationPageList'],
  endpoints: builder => ({
    saveRecommendationPage: builder.mutation<SuccessResponse<RecommendationPageRequest>, RecommendationPageRequest>({
      query: data => ({
        url: 'SaveCustomPage',
        method: 'POST',
        body: data,
        headers: {
          'Content-Type': contentTypes.applicationJson,
        },
      }),
      transformResponse: (response: SuccessResponse<RecommendationPageRequest>) => response,
      transformErrorResponse: response => response as ResponseError,
    }),
    getRecommendationPage: builder.query<SuccessResponse<RecommendationPageData>, number>({
      query: id => ({
        url: `${id}`,
        method: 'GET',
        headers: {
          'Content-Type': contentTypes.rawContentType,
        },
      }),
      transformResponse: (response: SuccessResponse<RecommendationPageData>) => response,
      transformErrorResponse: response => response as ResponseError,
    }),
    getRecommendationPageDetails: builder.query<RecommendationPageViewData, { pageName: any; customerId: any }>({
      query: ({ pageName, customerId }) => ({
        url: `/GetRecommendationPage?seoURL=${pageName}&enrollerID=${customerId}`,
        method: 'GET',
        headers: { 'Content-Type': applicationJson },
      }),
      transformResponse: (response: RecommendationPageViewData) => response,
    }),
    useEnableDisableRecommendationPage: builder.mutation<SuccessResponse<number>, number>({
      query: pageId => ({
        url: `/enable-disable/${pageId}`,
        method: 'POST',
      }),
      transformResponse: (response: SuccessResponse<number>) => response,
      transformErrorResponse: response => response as ResponseError,
    }),
  }),
});

export const {
  useGetRecommendationPageDetailsQuery,
  useUseEnableDisableRecommendationPageMutation,
  useSaveRecommendationPageMutation,
  useGetRecommendationPageQuery,
  useLazyGetRecommendationPageQuery,
} = recommendationPagesApi;
